import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'outline-dark' | 'outline-light' | 'ghost-light';
  href?: string;
  external?: boolean;
  onClick?: () => void;
  icon?: boolean;
  className?: string;
  type?: 'button' | 'submit';
}
const variantClasses: Record<string, string> = {
  primary: 'bg-brandgreen text-white hover:bg-brandgreen-dark border border-brandgreen',
  'outline-dark': 'bg-transparent text-navy border border-navy/20 hover:border-navy/50',
  'outline-light': 'bg-transparent text-white border border-white/25 hover:border-white/60',
  'ghost-light': 'bg-white/10 text-white border border-white/10 hover:bg-white/15'
};
export function Button({
  children,
  variant = 'primary',
  href,
  external = false,
  onClick,
  icon = false,
  className = '',
  type = 'button'
}: ButtonProps) {
  const classes = `inline-flex items-center justify-center gap-2 rounded-md px-5 py-3 text-sm font-semibold tracking-wide transition-colors duration-150 ${variantClasses[variant]} ${className}`;
  if (href) {
    return <a href={href} className={classes} onClick={onClick} target={external ? '_blank' : undefined} rel={external ? 'noreferrer' : undefined} data-id="element-180" data-mp="eqxxsnap0xfi">
        {children}
        {icon && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-181" data-mp="omiwabgjzfki" />}
      </a>;
  }
  return <button type={type} onClick={onClick} className={classes} data-id="element-182" data-mp="12lsc3a0uk7ny">
      {children}
      {icon && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-183" data-mp="xnz6ai3ghfo7" />}
    </button>;
}